import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, useMediaQuery, useTheme } from '@mui/material';
import { CssBaseline } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import * as Yup from "yup"

import { getLocalAccessToken } from "./http_comon"
import { useActions } from './hooks/useActions';
import { useTypedSelector } from './hooks/useTypedSelector';

import DefaultLayout from './containers/DefaultLayout';
import AdminLayout from './containers/AdminLayout';

import HomePage from './pages/default/HomePage';
import SignInPage from './pages/auth';

import AnnouncementTable from './pages/admin/Announcement/Table';
import AnnouncementCreate from './pages/admin/Announcement/Create';
import HashtagTable from './pages/admin/Hashtag/Table';

import NotFound from './pages/notfound';

import darkTheme from './UISettings/darkTheme';
import lightTheme from './UISettings/lightTheme';
import Announcements from './pages/default/Announcements';
import AboutUs from './pages/default/AboutUs';
import HowIsEventGoing from './pages/default/HowIsEventGoing';
import ContactsPage from './pages/default/ContactsPage';
import ForPartners from './pages/default/ContactsPage/ForPartners';
import ForCulturalInstitutions from './pages/default/ContactsPage/ForCulturalInstitutions';
import ForEducationalInstitutions from './pages/default/ContactsPage/ForEducationalInstitutions';
import ForGrantors from './pages/default/ContactsPage/ForGrantors';
import ForMedia from './pages/default/ContactsPage/ForMedia';
import ForPublicAndCharitableOrganizations from './pages/default/ContactsPage/ForPublicAndCharitableOrganizations';
import ForYouthSpacesAndCenters from './pages/default/ContactsPage/ForYouthSpacesAndCenters';
import AnnouncementPage from './pages/default/Announcements/AnnouncementPage';
import AnnouncementUpdate from './pages/admin/Announcement/Update';
import ProjectTable from './pages/admin/Project/Table';
import ProjectCreate from './pages/admin/Project/Create';
import ProjectUpdate from './pages/admin/Project/Update';
import Projects from './pages/default/Projects';
import ProjectPage from './pages/default/Projects/ProjectPage';
import ReportingImagesAdmin from './pages/admin/ReportingImage/Table';




const App = () => {
  const theme = useTheme();

  const { AuthUser } = useActions();
  const { isAuth, user } = useTypedSelector(store => store.auth);

  Yup.setLocale({
    mixed: {
      required: label => `${label.label} є обов'язковим`,
    },
    string: {
      min: label => `${label.label}, повинно бути принаймні ${label.min} символів`,
      max: label => `${label.label}, має бути менше ніж ${label.max} символів`,
    },
    number: {
      min: label => `${label.label}, повинно бути принаймні ${label.min}`,
      max: label => `${label.label}, має бути менше ніж ${label.max}`,
    }
  })

  return (
    <>
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark" />
        <Routes>

          <Route path="/" element={<DefaultLayout />}>
            <Route index element={<HomePage />} />
            <Route path="announcements" element={<Announcements />} />
            <Route path="/announcements/:urlSlug" element={<AnnouncementPage />} />
            <Route path="projects" element={<Projects />} />
            <Route path="/projects/:urlSlug" element={<ProjectPage />} />
            <Route path="about-us" element={<AboutUs />} />
            <Route path="how-is-event-going" element={<HowIsEventGoing />} />
            <Route path="contacts" element={<ContactsPage />} />

            <Route path="for-partners" element={<ForPartners />} />
            <Route path="for-cultural-institutions" element={<ForCulturalInstitutions />} />
            <Route path="for-educational-institutions" element={<ForEducationalInstitutions />} />
            <Route path="for-grantors" element={<ForGrantors />} />
            <Route path="for-media" element={<ForMedia />} />
            <Route path="for-public-and-charitable-organizations" element={<ForPublicAndCharitableOrganizations />} />
            <Route path="for-youth-spaces-and-centers" element={<ForYouthSpacesAndCenters />} />
          </Route>

          {/* <Route element={<AuthLayout />}>
            <Route path="/auth/signin" element={<SignIn />} />
            <Route path="/auth/signup" element={<SignUp />} />
          </Route> */}

          {isAuth ?
            <>
              {user.role == "Admin" && <Route path="/admin/" element={<AdminLayout />}>
                <Route index element={<AnnouncementTable />} />
                <Route path="announcements/create" element={<AnnouncementCreate />} />
                <Route path="announcements/update/:id" element={<AnnouncementUpdate />} />
                <Route path="projects" element={<ProjectTable />} />
                <Route path="projects/create" element={<ProjectCreate />} />
                <Route path="projects/update/:id" element={<ProjectUpdate />} />
                <Route path="hashtags" element={<HashtagTable />} />
                <Route path="reporting-images" element={<ReportingImagesAdmin />} />
              </Route>}
            </>
            : <>
              <Route path="/admin" element={<SignInPage />} />
            </>
          }
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ThemeProvider>
    </>
  );
}

export default App;
